import {
  CustomizationSelectedIngredient,
  CustomizationSelectedIngredientKindSection,
  CustomizationSelectedIngredientsContainer,
  CustomizationSelectedIngredientsList,
  CustomizationSelectedIngredientsListItem,
  CustomizationSelectedIngredientV2,
} from './components';

export const CustomizationSelectedIngredients = {
  Container: CustomizationSelectedIngredientsContainer,
  List: CustomizationSelectedIngredientsList,
  ListItem: CustomizationSelectedIngredientsListItem,
  Ingredient: CustomizationSelectedIngredient,
  IngredientV2: CustomizationSelectedIngredientV2,
  IngredientKindSection: CustomizationSelectedIngredientKindSection,
};
